import { Component, Input } from '@angular/core';
import { icon, latLng, marker, tileLayer } from 'leaflet';

@Component({
  selector: 'establishments-map',
  templateUrl: './establishments-map.component.html'
})
export class EstablishmentsMapComponent {

  @Input() set establishments(establishments) {
    this.setFitBounds(establishments);
    this.setMarkers(establishments);
  }

  @Input() set currentLocation(stringLocation) {
    const location = stringLocation.split(',').map(parseFloat);
    this.mapCenterOptions = latLng(location[0], location[1]);
  }

  markers = [];
  defaultLocation = { lat: -13.7013576, lng: -51.0536984 };
  fitBounds = [[this.defaultLocation.lat, this.defaultLocation.lng]];
  LAYER_OSM = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: 'Open Street Map' });
  mapCenterOptions = latLng(this.defaultLocation['lat'], this.defaultLocation['lng']);
  mapZoom = 12;

  public options = {
    layers: [this.LAYER_OSM],
    zoom: this.mapZoom,
    center: this.mapCenterOptions
  };

  constructor() {}

  setMarkers(establishments) {
    this.markers = [];
    establishments.forEach(establishment => this.setMarkerEstablishment(establishment));
  }

  setFitBounds(establishments) {
    const bounds = establishments.map(establishment => {
      if (establishment.addressess && establishment.addressess.length) {
        const { location } = establishment.addressess[0];
        return [
          location.coordinates ? location.coordinates[1] : location.lat,
          location.coordinates ? location.coordinates[0] : location.lng
        ];
      }
    }).filter(el => el);

    if (bounds.length) { this.fitBounds = bounds; }
  }

  setMarkerEstablishment(establishment) {
    if (establishment.addressess && establishment.addressess.length) {
      const image = (establishment && establishment.image && establishment.image.logo) ? establishment.image.logo : '';
      const name = (establishment && establishment.name) ? establishment.name : '';
      const address = this.getAddressAsString(establishment.addressess[0]);
      const mapCard = `
          <div>
            <div class="card-wrapper">
              <div class="image-card" style="background-image: url('${image}')"></div>
              <div class="card-content">
                <div class="card-content-wrapper">
                  <h2>${name}</h2>
                  <p>${address}</p>
                  <ul>
                    <li><p>$$</p></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        `;

      const { location } = establishment.addressess[0];
      const newMarker = marker(
        [
          location.coordinates ? location.coordinates[1] : location.lat,
          location.coordinates ? location.coordinates[0] : location.lng
        ],
        {
          icon: icon({
            iconSize: [50, 50],
            iconAnchor: [13, 41],
            iconUrl: `assets/pins/${establishment.category ? establishment.category.slug : 'beleza-e-bem-estar'}.svg`,
            shadowUrl: ''
          })
        }
      ).bindPopup(mapCard).openPopup();
      this.markers.push(newMarker);
    }
  }

  getAddressAsString(addressObject): string {
    const street = addressObject.street;
    const number = addressObject.number;
    const neighborhood = addressObject.neighborhood;
    const country = addressObject.county || addressObject.city;
    const state = addressObject.state;
    const cep = addressObject.cep || addressObject.zipCode;
    return street + ', ' + number + ', ' + neighborhood + ' - ' + country + '/' + state + ' - ' + cep;
  }

}
